import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import { Link } from 'react-router-dom';

function Main({ activeIndex }) {
    return (
        <Tab.Container id="list-group-tabs-example" defaultActiveKey="#link1">
            <Row>
                <Col sm={12}>
                    <ListGroup>

                        <ListGroup.Item as={Link} action to="/admissions" className="mb-3 p-3">
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Admissions
                        </ListGroup.Item>
                    </ListGroup>
                    <ListGroup>
                        <h4 className='mt-3 mb-3'>Undergraduate</h4>
                        <ListGroup.Item as={Link} action to="/btech" className={`p-3 ${activeIndex == 0 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            B.Tech.
                        </ListGroup.Item>
                        <h4 className='mt-3 mb-3'>Postgraduate</h4>
                        <ListGroup.Item as={Link} action to="/mtech" className={`p-3 ${activeIndex == 1 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            M.Tech.
                        </ListGroup.Item>
                        <ListGroup.Item as={Link} action to="/mtech-self-sponsored" className={`p-3 ${activeIndex == 6 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            M.Tech. Self-Sponsored
                        </ListGroup.Item>

                        {/* need to check  */}
                        <ListGroup.Item as={Link} action to="/msc" className={`p-3 ${activeIndex == 2 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            M.Sc.
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/master-of-public-policy-mpp" className={`p-3 ${activeIndex == 3 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Master of Public Policy (MPP)
                        </ListGroup.Item>

                        <h4 className='mt-3 mb-3'>Research</h4>
                        <ListGroup.Item as={Link} action to="/ms" className={`p-3 ${activeIndex == 4 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            M.S (Research)
                        </ListGroup.Item>

                        <ListGroup.Item as={Link} action to="/phd" className={`p-3 ${activeIndex == 5 ? " active" : ""}`}>
                            <i className="fas fa-chevron-circle-right me-3"></i>
                            Ph.D
                        </ListGroup.Item>
                    </ListGroup>
                </Col>
            </Row>
        </Tab.Container>
    );
}

export default Main;

